
$( document ).ready(function() {

  $(".marqee-menu > li").click(function () {
    $(this).siblings("li").removeClass("active");
    $(this).addClass("active");

    var index = $(".marqee-menu > li").index(this);
    
    $(".display > ul").removeClass("active");
    $(".display > ul").eq(index).addClass("active");

  });


  /* ==========================================================================
        * nav
  ==========================================================================*/

  //login按鈕的「登出」對話框
  if ($(window).width() >= 1080) {
    $('.nav .greeting').click(function (e) {
      $(this).toggleClass('expended');
      $(".nav .login").slideToggle(200);
      e.stopPropagation();

      $(window).click(function () {
        $(".nav .greeting").removeClass('expended');
        $(".nav .login").slideUp(200);
        $(window).off();
      });
    });
  }
  // if ($(window).width() < 1080) {
  //   var $black = $("header .black");


  //   var toggleBlack = function () {
  //     if ($black.hasClass("fade-in")) {
  //       $black.addClass("fade-out").removeClass("fade-in");
  //     } else {
  //       $black.addClass("fade-in").removeClass("fade-out");
  //     }
  //   };
  // }

  function togglePanel() {
    //右側隱藏 panel 按鈕列
    $("header .links").toggleClass("expended");
  }

  function toggleBlack() {
    var $black = $("header .black");

    if ($black.hasClass("fade-in")) {
      $black.addClass("fade-out").removeClass("fade-in");
    } else {
      $black.addClass("fade-in").removeClass("fade-out");
    }
  }

  if ($(window).width() < 992) {
    //991以下 的panel 和黑幕
    $(".links").click(function() {
      togglePanel();
      toggleBlack();
    });

    $(".black").click(function(e) {
      // toggleBlack();
      $(".links").removeClass("expended");
      e.stopPropagation();
    });

    $(".links .panel").click(function(e) {
      e.stopPropagation();
    });
  }

  if ($(window).width() >= 992) {
    //992以上  panel和黑幕

    var node = $(".links"); //因為在nav底下的元素  會被其他選單擋住  因而要拉高層級
    $("header").prepend(node);

    $(".links .panel .btn").click(function() {
      if (!$(".links").hasClass("expended")) {
        $(".links").addClass("expended");
        toggleBlack();
      } else {
        $(".links").removeClass("expended");
        toggleBlack();
      }
    });

    $(".black").click(function(e) {
      $(".links").removeClass("expended");
      toggleBlack();
    });
  }
  




  //========= 漢堡選單 (1080 以下) & 黑幕（共通元素） ========= 

  function check_menu() {
    if ($(window).width() < 1080) {
      $("header .menu li a").click(function (e) {
        if ($(this).next().hasClass("sub-cover")) {
          // console.log($(this));
          e.preventDefault();
        } else if ($(this).next().hasClass("dropdown")) {
          e.preventDefault();
        }
      });
    }
  }

  $window.on("load", function () {
    check_menu();
    $window.on("resize", check_menu);
  });


  if ($(window).width() < 1080) {
    $(".hamburger").click(function (e) {        //第一層選單


      $(".cover").addClass("active");
      $("main").css("tranform", "translateX(100px)")
      $('header .black').addClass("fade-in").removeClass("fade-out");
      $(".links ").removeClass("expended");       //關閉 panel

    });

    // $(".menu > li > a:not([href])").click(function (e) {    //第二層選單
    $(".menu > li > a").click(function (e) {    //第二層選單
      if ($(this).next().hasClass("sub-cover")) {

        $(this).addClass("active");
        $(".cover").addClass("sub-open");
        // scrollWrap();
      }
    });

    $('a.symbol-down').click(function () {      //第二層選單  的下拉選單
      $(this).next('.dropdown').slideToggle(300);
      $(this).toggleClass("expended");
    });

    function closeAll() {
      $(".cover").removeClass("active");              //關閉 第一層
      $(".cover").removeClass("sub-open");            //關閉 第二層 (中第一層元素)

      $("a.symbol-down.expended").trigger("click");   //關閉 第二層 下拉選單
      toggleBlack();

      if ($(".menu > li > a").hasClass("active")) {
        $(".menu > li > a").removeClass("active");      //關閉 第二層
      }

      if ($("a.symbol-down").hasClass("expended")) {
      }
    }

    $("header .black").click(function (e) {
      closeAll();
    });

    $(".esc").click(function (e) {               //第一層、第二層 的離開按鈕
      closeAll();
    });

    $(".return").click(function (e) {            //第二層 的返回按鈕
      $(".cover").removeClass("sub-open");
      $(".menu > li > a").removeClass("active");
      $("a.symbol-down.expended").trigger("click");
    });
  }

  
  // ========= 下拉選單 =========

  if ($(window).width() > 1079) {

    $("header .nav .menu > li").hover(function () {     //第一層
      $(this).children('.sub-cover').stop(true, false, true).slideDown(300);
    }, function () {
      $(this).children('.sub-cover').stop(true, false, true).slideUp(300);
    });

    $("header .sub-cover li").hover(function () {       //第二層
      $(this).children('.dropdown').stop(true, false, true).slideDown(300);
    }, function () {
      $(this).children('.dropdown').stop(true, false, true).slideUp(300);
    });
  }
  
  
    function fixedNav() {
    if (window.pageYOffset > 180) {
      $("header .nav").addClass("sticky");
    } else {
      $("header .nav").removeClass("sticky");
    }
  }

  window.onscroll = function () { fixedNav(); };
  
  //麵包屑不用連結
  $('.breadcrumb a').attr("href", "#").css("cursor", "default");




  /* ==========================================================================
    * nav End
    ==========================================================================*/









  $(".imgLiquidFill").imgLiquid();

  $("select:not(.nondropkick)").each(function() {
    $(this).dropkick({
        mobile: true,
    });
  });
  
  $('.nondropkick:not(.notEditable)').editableSelect({
    effects: 'slide',
    duration: 200,
  });

  $('[data-fancybox^="gallery#download"]').fancybox({
    loop: true,
    buttons : [
        "zoom",
        "fullScreen",
        'close',
    ],
  });
  
  $('[data-fancybox="gallery#locations"]').fancybox({
    loop: true,
    buttons : [
        "zoom",
        "fullScreen",
        'close',
    ],
  });
  
//有4個頁面有商品清單(seed、hardware、machine、inquiry-special)
//並有各商品的細項介紹(彈跳視窗)，各彈跳視窗中，還有照片輪播集，各商品照片輪播為獨立清單
  $('#orders-seed a[data-fancybox]').each(function (index) {  
    index++;
    var attr = "#seed-item0" + index;
    $(this).attr("data-src", attr);
    
    var independent = $(this).attr("data-fancybox");
    $(this).attr("data-fancybox", independent+index);

    var proto = $("#seed-item01").html();
    proto = `<div id="seed-item0${index}" style="display: none;">${proto}</div>`;
    
    $("#orders-seed").append(proto); //用迴圈讓需要輪播的項目，在頁面尾部建立隱藏的彈跳視窗
    // console.log(tem);
  });
  

  $('#orders-hardware a[data-fancybox]').each(function (index) {    
    index++;
    var attr = "#hardware-item0" + index;
    $(this).attr("data-src", attr);

    var independent = $(this).attr("data-fancybox");  
    $(this).attr("data-fancybox", independent+index);

    var proto = $("#hardware-item01").html();
    proto = `<div id="hardware-item0${index}" style="display: none;">${proto}</div>`;
    $("#orders-hardware").append(proto);
  });

  $('#orders-machine a[data-fancybox]').each(function(index){
    index++;
    var attr = "#machine-item0" + index;
    $(this).attr("data-src", attr);

    var independent = $(this).attr("data-fancybox");
    $(this).attr("data-fancybox", independent+index);

    var proto = $("#machine-item01").html();
    proto = `<div id="machine-item0${index}" style="display: none;">${proto}</div>`;
    $("#orders-machine").append(proto);
  });

  $('#orders-inquiry-special a[data-fancybox]').each(function(index){
    index++;
    var attr = "#inquiry-item0" + index;
    $(this).attr("data-src", attr);

    var independent = $(this).attr("data-fancybox");
    $(this).attr("data-fancybox", independent+index);
    
    var proto = $(" #inquiry-item01").html();
    proto = `<div id="inquiry-item0${index}" style="display: none;">${proto}</div>`;
    // console.log(proto);
    $("#orders-inquiry-special").append(proto);
  });

  
  /* ==========================================================================
            * 共同元素
  ==========================================================================*/

  $(".date-picker input").each(function() {
    $(this).dateTimePicker({
      limitMax: null, 
      limitMin: null, 
      monthName: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一', '十二'],
      dayName: ['日', '一', '二', '三', '四', '五', '六'],
      // mode: 'date',  // "date" or "dateTime"
    });
  });
  
  // 各頁面的 dashboard 的按鈕列，在 992px 以下 變為下拉選單。
  $("div[class^='nav-'] .toggle").click( function(e) {
    $(this).next('ul').stop(true, false, true).slideToggle(200);
    $(this).toggleClass('active');
    e.stopPropagation();  
  });
  
  $(window).click(function () {
    if ($("div[class^='nav-'] .toggle").hasClass("active")) {
      $("div[class^='nav-'] .toggle").next('ul').stop(true, false, true).slideUp(200);
      $("div[class^='nav-'] .toggle").removeClass('active');    }
  });
  

  /* ==========================================================================
            * 頁面區塊
  ==========================================================================*/
  /*== index  0-0 =========================== */

  $('.video-slick a').hover(function () {  
    $(this).toggleClass('active');
  });

  /*== question  0-1 =========================== */

  $('#question-page .nav .hello').click(function (e) {  
    $(this).toggleClass('expended');
    $(".login").slideToggle(200);
    e.stopPropagation();
  });

  /*== orders  1-1-1 =========================== */
  

  // if ($(window).width() > 991){
  //   $('#orders .btn-order').click(function (){
  //     $('#orders .modal').addClass('active');
  //     setTimeout(function(){
  //       $('#orders .modal').removeClass('active');
  //     }, 7000);
  //   });
  // }
  

  $('#orders .btn-order').click(function (){
    $('#orders .modal').addClass('active');


    function wait(){
      $('#orders .modal').removeClass('active');
    }

    setTimeout(wait, 5000);

    // setTimeout(function(){
    //   $('#orders .modal').removeClass('active');
    // }, 5000);

    $('#orders .delete').click(function () {
      $('#orders .modal').removeClass("active");
      
      // clearTimeout(wait);
    });

  });

  //搜尋隱藏
  $('#orders .search-result').hide();

  $('#orders input[type="submit"]').click(function (e) {
    e.preventDefault();
    $('#orders .search-result').fadeIn();
  });
  $('#orders .clear').click(function () {
    $('#orders .search-result').hide();
  });

  /*== orders-pe  1-1-3 =========================== */
  $('#orders-pe input[type="radio"][id^="type"]').click(function (){
    var index = $(this).attr('id');
    $('#orders-pe .demopicture img').attr('src','styles/images/1-1-3-hole-'+index+'.png').hide();
        
    $('#orders-pe .demopicture img').fadeIn();

    // $("#orders-pe .hole").html( "邊距" );
    // $("#orders-pe .margin").html( "洞距" );

    if($("#type01").is(':checked')){
      $("#margin-width").attr("disabled","disabled");
      $("#orders-pe .margin").html( "" );
    } else {
      $("#margin-width").removeAttr('disabled');
      $("#orders-pe .margin").html( "邊距" );
    }
        
  });

  $('#orders-pe input#type01').trigger('click');
  

  $("#margin-width").change(function(){
    $("#orders-pe .margin").html( $(this).val()+"(尺)" );
  });
  
  $("#hole-width").change(function(){
    $("#orders-pe .hole").html( $(this).val()+"(尺)" );
  });

  /*==  1-1-4 =========================== */

  $('a[lightcase]').lightcase();

  /*== orders-inquiry  1-3-1 =========================== */

  $( "#orders-inquiry .inquiry-done" ).change(function() {

    if ( $(this).val() == "done" ) {
      $( "#orders-inquiry .yet").hide();
      $( "#orders-inquiry .done").show();
    } else if ( $(this).val() == "yet" ) {
      $( "#orders-inquiry .yet").show();
      $( "#orders-inquiry .done").hide();  
    }

  });

  /*== orders-hardware  1-3-2 =========================== */

  $( "#orders-inquiry-fertilizer .inquiry-done" ).change(function() {

    if ( $(this).val() == "done" ) {
      $( "#orders-inquiry-fertilizer .yet").hide();
      $( "#orders-inquiry-fertilizer .done").show();
    } else if ( $(this).val() == "yet" ) {
      $( "#orders-inquiry-fertilizer .yet").show();
      $( "#orders-inquiry-fertilizer .done").hide();  
    }

  });
  /*== announce  4-1 =========================== */

  $("#announcement table tr").click(function () {
    // $(this).find('a[target]').trigger('click', ["e"]);
    console.log($(this));
    // e.preventDefault();
    // e.stopPropagation();

    window.open("styles/file/TEST.pdf");

  });
  
  /*== calendar  5-2 =========================== */


  // $('#calendarEdit td.inner-detail ').each(function (index) {
  //   var sum = "";

  //   if ( $(this).children("a").length >1 ){
  //     $(this).children("a").map(function (e) {
  //       if ( e > 0) {
  //         $(this).css("display","none");
  //       }
  //       var text = $(this)[0].innerHTML;        
  //       sum = sum +`<li>${text}</li>`;
        
  //       // console.log(sum);
  //     });

  //     $("#calendar").append(`
  //       <div id="calendar-dialogue${index}" style="display: none;">
  //         <div class="group">
  //           <div class="time">2017/6/9</div><span>星期五</span>
  //           </div>
  //         <ul class="noneStyle">${sum}</ul>
  //       </div>`
  //     );

  //     $(this).append(`<a data-fancybox="" data-src="#calendar-dialogue${index}" href="javascript:;">more</a>`);
  //   }

  // });  


  /*== location  7-1 =========================== */

  $("#forum .group a").click(function(e){
    e.preventDefault();
    $("#forum .group a").removeClass("active");
    $(this).addClass("active");

    var dataPage = $(this).attr("data-page");
    
    
    $("#forum .right-wrap ul").hide();

    $("#forum .right-wrap ul[class*=page-" + dataPage+"]").fadeIn(300);
  });

  // $("#forum .right-wrap li").hover(function(){
    
  // });
  $("#forum .right-wrap li").hover(function(){
    $(this).children("a").toggleClass("active");
  });
  /*== location  7-1 =========================== */

  $('#locations .navToggle').click(function (){
    $(this).parent('.info').toggleClass("expended");
  });

  $('#locations a.say').click(function (){        // 左側訊息欄位
    $(this).next('.toggle').stop(true, false, true).slideToggle(400);
  });
  


  // 右側地圖欄位
  $('#locations .map').tinyMap({
    'center': ['24.2454324', '120.7763'],
    'zoom': 12,
    styles: [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"on"},{"color":"#716464"},{"weight":"0.01"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"visibility":"simplified"}]},{"featureType":"poi.attraction","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"},{"color":"#a05519"},{"saturation":"-13"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#84afa3"},{"lightness":52}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"visibility":"on"}]}],
    'markerWithLabel': true,
    'marker': [
      {
        'addr': ['24.2454324', '120.7126192'],
        'text': `<div class="infobox">
          <div>
            <img src="./styles/images/0-0-logo-phone.png"/>豐原供應中心
          </div>
          <div>
            <img src="./styles/images/7-1-address.svg"/>台中市豐原區圓環南路27號
          </div>
          <div>
            <img src="./styles/images/7-1-phone.svg"/>04-25260835
          </div>
        </div>`,
        'newLabel': '豐原供應中心',
        'newLabelCSS': 'maker-labels',
        'icon': {
          'url': './styles/images/7-1-maker.png',
          'scaledSize': [50, 70]
        }
      }, {
        'addr': ['24.276501', '120.777262'],
        'text': `<div class="infobox">
          <div>
            <img src="./styles/images/0-0-logo-phone.png"/>石岡供應中心
          </div>
          <div>
            <img src="./styles/images/7-1-address.svg"/>台中市石岡區萬安里豐勢路1006號
          </div>
          <div>
            <img src="./styles/images/7-1-phone.svg"/>04-25721261
          </div>
        </div>`,
        'newLabel': '石岡供應中心',
        'newLabelCSS': 'maker-labels',
        'icon': {
          'url': './styles/images/7-1-maker.png',
          'scaledSize': [50, 70]
        }
      }, {
        'addr': ['24.244770', '120.839760'],
        'text': `<div class="infobox">
          <div>
            <img src="./styles/images/0-0-logo-phone.png"/>石角供應中心
          </div>
          <div>
            <img src="./styles/images/7-1-address.svg"/>台中市東勢區福隆里東坑路130號
          </div>
          <div>
            <img src="./styles/images/7-1-phone.svg"/>04-25876953
          </div>
        </div>`,
        'newLabel': '石角供應中心',
        'newLabelCSS': 'maker-labels',
        'icon': {
          'url': './styles/images/7-1-maker.png',
          'scaledSize': [50, 70]
        }
      }, {
        'addr': ['24.211974', '120.839328'],
        'text': `<div class="infobox">
          <div>
            <img src="./styles/images/0-0-logo-phone.png"/>慶東供應中心
          </div>
          <div>
            <img src="./styles/images/7-1-address.svg"/>台中市東勢區慶東里東關路5段505號
          </div>
          <div>
            <img src="./styles/images/7-1-phone.svg"/>04-25852288
          </div>
        </div>`,
        'newLabel': '慶東供應中心',
        'newLabelCSS': 'maker-labels',
        'icon': {
          'url': './styles/images/7-1-maker.png',
          'scaledSize': [50, 70]
        }
      }
    ],
  });

  $('#locations .info-block a[data-addr]').each(function(){
    $(this).on('click', function(){
    
      var mapAddr = $(this).attr("data-addr");
      $('.map').tinyMap('panTo', mapAddr);
    
    });
  });

  /*== forum-product  10-1 =========================== */
  $('#forum-product .toggle').click(function (){
    $(this).parent('.right-wrap').toggleClass("expended");
  });
  /*== forum  6-1 =========================== */
  
  $('#forum .toggle').click(function (){
    $(this).parent('.right-wrap').toggleClass("expended");
  });

  
  
/*== forum-product  10-1 =========================== */

  $("#forum-product .group a").click(function(e){
    e.preventDefault();
    $("#forum-product .group a").removeClass("active");
    $(this).addClass("active");

    $("#forum-product .right-wrap ul").hide();
    $("#forum-product .right-wrap ul").fadeIn(300);
  });
  




}); // document ready End


/* ==========================================================================
          *animation scroll trigger
==========================================================================*/


var $animation_elements = $(".animate");

var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = window_top_position + window_height;


  function addView() {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = element_top_position + element_height;

    if (
      element_bottom_position >= window_top_position &&
      element_top_position <= (window_bottom_position - (window_height / 6))  //讓主體物件在viewport中央位置，再起始動畫
    ) {
      $element.addClass("in-view");
    }
    if ($element.hasClass("bottom")) {
      if (element_top_position <= (window_bottom_position)) { $element.addClass("in-view"); }
    }
  };

  $.each($animation_elements, addView);
  $(".sub-menu").each(addView);
  
  $(".container").each(addView);
}
$window.on("load", function() {
  $window.on("scroll resize", check_if_in_view);
  $window.trigger("scroll");
});

/* ==========================================================================
          * slick
==========================================================================*/


// if( $( window ).width() < 992 ){
//   $('.marqee .display .list').slick({
//     dots: false,
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//   });
// }
  
  
$(".landindSlick").slick({
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true
});
  
$(".productSlick").slick({
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 540,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});
  
  
if( $( window ).width() < 1200 ){

  $(".video-slick").slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
}



// function bindEvent(){

//   $("#calendarEdit > table > tbody td").each(function () {
//     var tem = $(this).text();
    
//     $(this).html(`<div><p>${tem}</p></div>`);
//   });


//   var target1 = $("#calendarEdit > table > tbody > tr:nth-child(2) > td:nth-child(6)");
//   var event1 = `<a class="" href="noticeboard-in.html">元帥500”→250元、蓋美525→三包1050元</a>`;
  
//   target1.addClass("event");
//   target1.children("div").append(event1);

  
//   var target2 = $("#calendarEdit > table > tbody > tr:nth-child(4) > td:nth-child(2)");
//   var event2 = `<a class="" href="noticeboard-in.html">5/5店長會議、時間：早上九點、地點：安溪</a>`;
  
//   target2.addClass("event");
//   target2.children("div").append(event2);


//   var target3 = $("#calendarEdit > table > tbody > tr:nth-child(5) > td:nth-child(4)");
//   var event3 = `<a class="" href="noticeboard-in.html">6/5店長會議、時間：早上九點、地點：安溪</a>`;
  
//   target3.addClass("event");
//   target3.children("div").append(event3);



//   var target2_1 = $("#calendarEdit > table > tbody > tr:nth-child(3) > td:nth-child(5)");
//   var event2_1 = `
//     <a class=""  data-fancybox="" data-src="#calendar-dialogue01" href="javascript:;" > 1.買金優根10K一包送金優根K一包、2.買水叮噹/蟲真驚/斯米隆等3L ...</a>

//     <a class="more" data-fancybox="" data-src="#calendar-dialogue01" href="javascript:;">more</a>`;
//     // <a class="more">more</a>`;
  
//   target2_1.addClass("event").addClass("infobox");
//   target2_1.children("div").append(event2_1);


//   $("#calendar").append(`
//     <div id="calendar-dialogue01" style="display: none;">
//       <div class="group">
//         <div class="time">2017/6/9</div><span>星期五</span>
//         </div>
//       <ul class="noneStyle">
//         <li>
//           <a href="noticeboard-in.html">1.買金優根10K一包送金優根K一包、2.買水叮噹/蟲真驚/斯米隆等3L ...</a>    
//         </li>
//         <li>
//           <a href="noticeboard-in.html">6/5店長會議、時間：早上九點、地點：安溪</li></a>
//         <li>
//           <a href="noticeboard-in.html">元帥500”→  250元、蓋美525  →   三包1050元</li></a>
//       </ul>
//     </div>`
//   );

  

// }


